import React from 'react';

import { Drawer } from 'antd';

import Schedule from './Schedule';

const DrawerSchedule = props => {
  const { visible, handleClose, schedule } = props;

  return (
    <Drawer
      title={'График движения'}
      placement="left"
      width={896}
      destroyOnClose={true}
      visible={visible}
      onClose={handleClose}
    >
      <Schedule schedule_data={schedule} />
    </Drawer>
  );
};

export default DrawerSchedule;
